import { last } from 'lodash';

import { useTrackingContext } from '@zapier/toolbox-tracking';

import { useFormContext } from 'app/developer-v3/components/PartnerSupportForm/contexts/FormContext';

import {
  AVRO_EVENT_USER_INTERACTION,
  EVENT_CONTACT_INIT,
  EVENT_CONTACT_STEP,
} from 'app/developer-v3/components/PartnerSupportForm/constants';

const useTrackPath = () => {
  // can't `useRef` here as we need this to be stateful between `useTrackPath` instances.
  const { lastTrackedPath, setLastTrackedPath } = useFormContext();

  // can't move this to `FormContext` completely as tracking context relies on `FormContext`
  const { trackEvent } = useTrackingContext();

  const trackPath = (nodePath: string, additionalPath?: string) => {
    const crumbs = nodePath.split('.');

    if (last(crumbs) === 'help') {
      // drop help as that node is a container of several steps
      crumbs.pop();

      // first of which is confirming the answers, but only if we have more than just the topic question
      if (last(crumbs) !== 'topic') {
        crumbs.push('confirm');
      }
    }

    if (additionalPath) {
      crumbs.push(additionalPath);
    }

    const path = crumbs.join('.');

    if (lastTrackedPath !== path) {
      const eventName = lastTrackedPath
        ? EVENT_CONTACT_STEP
        : EVENT_CONTACT_INIT;

      trackEvent(eventName, {
        path,
      });
      trackEvent(AVRO_EVENT_USER_INTERACTION, {
        system_name: 'partner_contact_form',
        interaction_name: eventName.split(' ').join('_').replace(/:/g, ''),
        option_selected: path,
        event_action: 'click',
      });

      setLastTrackedPath(path);
    }
  };

  return trackPath;
};

export default useTrackPath;
